import React, { useState, useEffect } from "react";
import { withRouter, Link } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import PriceTag from "./PricePlans/PriceTag";
import ThreeBtn from "./PricePlans/ThreeBtn";

import {
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  Zoom,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import userService from "../services/userService";

function Subscription({
  price_detail,
  planName,
  planList,
  btn_list,
  plan_mode,
  hide,
  currentUser,
  plan_id,
  defaultPlan,
}) {
  const [planPeriod, setplanPeriod] = useState(null);
  const userDetails = useSelector((user) => user);
  const [currentPlan, setCurrentPlan] = useState();
  const [currentplancheck, setCurrentplancheck] = useState(false);

  useEffect(() => {
    console.log("planName_", userDetails, planName);
    if (planPeriod) {
      console.log(planPeriod, "planPeriod", planName);
    }
  }, [planPeriod]);

  useEffect(() => {
    if (userDetails) {
      async function fetchPlan() {
        const email = userDetails?.user?.currentUser?.email;
        const res = await userService.getUserProfile(email);
        const userData = res.data.user;
        setCurrentPlan(userData.plan.name);
      }
      fetchPlan();
    }
  }, [currentplancheck]);

  const isCurrentPlan =
    currentPlan === planName && !currentUser?.isAdmin && hide !== true;

  return (
    <Zoom in={true} style={{ transitionDelay: "100ms" }}>
      <Card
        elevation={isCurrentPlan ? 12 : 4}
        sx={{
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          borderRadius: 4,
          transition: "all 0.3s ease-in-out",
          position: "relative",
          // border: isCurrentPlan
          //   ? "4px solid #667eea"
          //   : "1px solid rgba(0,0,0,0.12)",
          background: isCurrentPlan
            ? "linear-gradient(145deg, #1976d2 0%, #e8eeff 100%);"
            : "white",
          transform: isCurrentPlan ? "scale(1.05)" : "scale(1)",
          "&:hover": {
            transform: isCurrentPlan
              ? "scale(1.05) translateY(-8px)"
              : "translateY(-8px)",
            boxShadow: isCurrentPlan
              ? "0 20px 60px rgba(102, 126, 234, 0.5)"
              : "0 12px 40px rgba(102, 126, 234, 0.3)",
          },
        }}
      >
        {isCurrentPlan && (
          <Box
            sx={{
              position: "absolute",
              top: 26,
              right: -33,
              transform: "rotate(45deg)",
              bgcolor: "#ee942dff",
              color: "white",
              px: 6,
              py: 0.7,
              fontSize: "12px",
              fontWeight: 700,
              zIndex: 10,
              boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
            }}
          >
            CURRENT
          </Box>
        )}

        <CardContent
          sx={{
            p: 3,
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          {/* Plan Name */}
          <Typography
            variant="h5"
            sx={{
              textAlign: "center",
              fontWeight: 700,
              mb: 2,
              color: isCurrentPlan ? "white" : "#1a1a2e",
            }}
          >
            {planName}
          </Typography>

          {/* Period Selector */}
          {!defaultPlan && (
            <Box sx={{ mb: 2, display: "flex", justifyContent: "center" }}>
              <ThreeBtn
                btn_list={btn_list}
                planPeriod={(period) => setplanPeriod(period)}
                pricebox={true}
              />
            </Box>
          )}

          {/* Price */}
          <Box sx={{ flexGrow: 1 }}>
            <PriceTag
              price_detail={price_detail}
              planPeriod={planPeriod}
              planName={planName}
              planList={planList}
              plan_mode={plan_mode}
              bg_color={"bg-white"}
              price_size={"50px"}
              hide={hide}
              plan_id={plan_id}
              defaultPlan={defaultPlan}
              isCurrentPlan={isCurrentPlan}
              setCurrentPlan={setCurrentPlan}
              setCurrentplancheck={setCurrentplancheck}
            />
          </Box>

          {/* Learn More */}
          <Button
            component={Link}
            to={{ pathname: hide ? "/homepricedetails" : "/pricedetails" }}
            variant="outlined"
            fullWidth
            startIcon={<InfoIcon />}
            sx={{
              mt: 2,
              borderRadius: 3,
              fontWeight: 600,
              borderColor: isCurrentPlan ? "#667eea" : "primary.main",
              color: isCurrentPlan ? "#667eea" : "primary.main",
            }}
          >
            Learn more
          </Button>
        </CardContent>
      </Card>
    </Zoom>
  );
}

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
});

export default connect(mapStateToProps)(withRouter(Subscription));
